import { render, staticRenderFns } from "./Queue.vue?vue&type=template&id=5c3f80d0&"
import script from "./Queue.vue?vue&type=script&lang=ts&"
export * from "./Queue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports